import FormBuilder from "components/Inputs/FormBuilder";
import { DataFields } from "./DataFields";

export default function ColorBaseModule({ dataInstance, register, errors, changeDataFunction, changeCompletePicker }) {

  return (<>
    <FormBuilder 
      dataDields={DataFields}
      dataInstance={dataInstance}
      register={register}
      errors={errors}
      changeDataFunction={changeDataFunction}
      changeCompletePicker={changeCompletePicker}
    />
  </>)
}